/** Read Vite env with fallback to legacy CRA `REACT_APP_*` names. */
export function env(key: string, fallback = ""): string {
  const viteKey = `VITE_${key}` as keyof ImportMetaEnv;
  const craKey = `REACT_APP_${key}` as keyof ImportMetaEnv;

  const fromVite = import.meta.env[viteKey];
  if (typeof fromVite === "string" && fromVite !== "") {
    return fromVite;
  }

  const fromCra = import.meta.env[craKey];
  if (typeof fromCra === "string" && fromCra !== "") {
    return fromCra;
  }

  return fallback;
}

export function apiBaseUrl(): string {
  return env("API_URL", "http://localhost:8000/api");
}

export function apiOrigin(): string {
  return apiBaseUrl().replace(/\/api\/?$/, "");
}
